module.exports = __webpack_public_path__ + "img/gyant_brown_ba_detail_rsh(1).8802886e.jpg";